/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{JSONMap as o}from"../../../core/jsonMap.js";const e=new o({none:"none",lowFourBit:"low-four-bit",highFourBit:"high-four-bit",absoluteValue:"absolute-value",moduloTen:"modulo-ten"});export{e as fieldTransformTypeKebabDict};
